import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm mt-8" }
const _hoisted_2 = { class: "px-6 space-y-6" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["aria-invalid"]
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_6 = ["aria-invalid"]
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["aria-invalid"]
const _hoisted_10 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}

import { ref, reactive, watch, computed } from 'vue'
import { SOFTWARE_LOOKUPS } from '@/constants/lookups'
import TagAutocomplete from '@/components/inputs/TagAutocomplete.vue'
import { useCompanyRegistrationStore } from '@/stores/companyRegistrationStore'
import { useCompanyIndustryProfileStore } from '@/stores/companyIndustryProfileStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'OperationsOverviewStep',
  props: {
    data: {}
  },
  emits: ['update', 'back', 'next'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const localData = ref({ ...props.data })

const registrationStore = useCompanyRegistrationStore()
const industryProfileStore = useCompanyIndustryProfileStore()

const errors = reactive<{ [key: string]: string }>({})

watch(localData, (val) => emits('update', val), { deep: true })

const selectedIndustry = computed(() => {
  const industryValue = localData.value.industry
  if (!industryValue) return null
  const industryId = Number(industryValue)
  if (!Number.isFinite(industryId)) return null

  const industries = registrationStore.industries ?? []
  return industries.find((industry) => industry.id === industryId) ?? null
})

const resolvedIndustryName = computed(() => {
  if (selectedIndustry.value?.name) {
    return selectedIndustry.value.name
  }

  const raw = localData.value.industry
  if (raw == null || raw === '') return ''

  if (typeof raw === 'string') return raw.trim()
  return String(raw)
})

const shouldShowMiningOperations = computed(
  () => industryProfileStore.resolve(resolvedIndustryName.value)?.sections.site_operations ?? false
)

const industrySoftwareKey = computed(() => {
  const normalized = resolvedIndustryName.value.trim().toLowerCase()
  return normalized !== '' && normalized.includes('mining') ? 'mining' : 'default'
})

const softwareOptions = computed(() => {
  const key = industrySoftwareKey.value
  const options = SOFTWARE_LOOKUPS[key] ?? SOFTWARE_LOOKUPS.default
  return [...options]
})

const softwareSelection = computed<string[]>({
  get() {
    return Array.isArray(localData.value.softwareUsed) ? localData.value.softwareUsed : []
  },
  set(value) {
    localData.value.softwareUsed = value
  },
})

function prevStep() {
  emits('back')
}

function validateAndProceedStep4() {
  for (const k in errors) delete errors[k]

  if (Object.keys(errors).length === 0) {
    emits('next')
  }
}

watch(shouldShowMiningOperations, (show) => {
  if (show) return
  delete errors.fieldRoster
  delete errors.facilities
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6 pb-6" }, [
      _createElementVNode("div", { class: "leading-none font-semibold text-lg" }, "Operations Overview"),
      _createElementVNode("div", { class: "text-muted-foreground text-sm" }, " Tell us about your day-to-day operations and facilities ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (shouldShowMiningOperations.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Field Roster", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localData.value.fieldRoster) = $event)),
              placeholder: "Describe your typical roster arrangements (e.g., 2 weeks on / 1 week off, FIFO, residential)",
              class: "w-full min-h-24 border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
              "aria-invalid": !!errors.fieldRoster
            }, null, 8, _hoisted_4), [
              [_vModelText, localData.value.fieldRoster]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs text-muted-foreground mt-1" }, " Explain your typical work rotation and roster patterns ", -1)),
            (errors.fieldRoster)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errors.fieldRoster), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Typical Hours", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localData.value.typicalHours) = $event)),
          type: "text",
          placeholder: "12-hour shifts, 7 days per week",
          class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
          "aria-invalid": !!errors.typicalHours
        }, null, 8, _hoisted_6), [
          [_vModelText, localData.value.typicalHours]
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs text-muted-foreground mt-1" }, "Standard working hours and shift patterns", -1)),
        (errors.typicalHours)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errors.typicalHours), 1))
          : _createCommentVNode("", true)
      ]),
      (shouldShowMiningOperations.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Facilities", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localData.value.facilities) = $event)),
              placeholder: "Describe your facilities (e.g., accommodation camps, offices, processing plants, workshops)",
              class: "w-full min-h-24 border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
              "aria-invalid": !!errors.facilities
            }, null, 8, _hoisted_9), [
              [_vModelText, localData.value.facilities]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs text-muted-foreground mt-1" }, " List and describe your key facilities and infrastructure ", -1)),
            (errors.facilities)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(errors.facilities), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex items-center gap-2 mb-1" }, [
          _createElementVNode("label", { class: "block text-sm font-medium" }, "Software Used"),
          _createElementVNode("span", { class: "text-muted-foreground text-xs" }, "(ERP, CAD, specialized tools)")
        ], -1)),
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-xs text-muted-foreground mb-2" }, " Select all enterprise software and systems your company uses ", -1)),
        _createVNode(TagAutocomplete, {
          modelValue: softwareSelection.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((softwareSelection).value = $event)),
          options: softwareOptions.value,
          placeholder: "Search software or add your own",
          clearable: ""
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createElementVNode("div", { class: "flex justify-between items-center px-6 pt-6" }, [
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-md border border-border text-sm hover:bg-muted",
        onClick: prevStep
      }, " Back "),
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-md bg-brand text-white text-sm hover:opacity-90",
        onClick: validateAndProceedStep4
      }, " Next ")
    ])
  ]))
}
}

})